// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application";
import DropzoneController from "./dropzone_controller";
import RendererController from "./renderer_controller";
import GroupInputsController from "./group_inputs_controller";
import DateRangeController from "./date_range_controller";
import InlineEditorController from "./inline_editor_controller";
import InlineEditorFormController from "./inline_editor_form_controller";
import AjaxRequestController from "./ajax_request_controller";
import LoadingIndicatorController from "./loading_indicator_controller";
import FormValidationController from "./form_validation_controller";
import IpCheckerController from "./ip_checker_controller";
import FileLoadController from "./file_load_controller";

application.register("dropzone", DropzoneController);
application.register("renderer", RendererController);
application.register("groupInputs", GroupInputsController);
application.register("dateRange", DateRangeController);
application.register("inlineEditor", InlineEditorController);
application.register("inlineEditorForm", InlineEditorFormController);
application.register("ajaxRequest", AjaxRequestController);
application.register("loadingIndicator", LoadingIndicatorController);
application.register("formValidation", FormValidationController);
application.register("ipChecker", IpCheckerController);
application.register("fileLoad", FileLoadController);
